(function () {
  "use strict";

  function bindSticky(root) {
    var sticky =
      document.querySelector("[data-ecomato-sticky]") ||
      root.querySelector("[data-ecomato-sticky]");
    if (!sticky) return;

    var tokenSource =
      document.querySelector('[data-ecomato-section="custom-product-focus"]') ||
      document.querySelector(".ecomato-section--pdp") ||
      document.body;

    [
      "--ecomato-primary",
      "--ecomato-accent",
      "--ecomato-sale",
      "--ecomato-font-family",
      "--ecomato-heading-font",
      "--ecomato-text",
      "--ecomato-muted",
      "--ecomato-border",
      "--ecomato-surface",
      "--ecomato-radius",
    ].forEach(function (prop) {
      var value = getComputedStyle(tokenSource).getPropertyValue(prop).trim();
      if (value) sticky.style.setProperty(prop, value);
    });

    // Ensure CTA fill always resolves to a real color (never Dawn RGB channels).
    if (!getComputedStyle(sticky).getPropertyValue("--ecomato-accent").trim()) {
      sticky.style.setProperty(
        "--ecomato-accent",
        getComputedStyle(sticky).getPropertyValue("--ecomato-primary").trim() ||
          "#8b5e3c",
      );
    }
    if (!getComputedStyle(sticky).getPropertyValue("--ecomato-surface").trim()) {
      sticky.style.setProperty("--ecomato-surface", "#ffffff");
    }

    if (sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }

    var onScroll = function () {
      var buybox = document.querySelector(
        ".cp-info, .cp-buy-btn, .ecomato-section--pdp",
      );
      if (!buybox) {
        sticky.setAttribute("data-visible", window.scrollY > 420 ? "true" : "false");
        return;
      }
      sticky.setAttribute(
        "data-visible",
        buybox.getBoundingClientRect().bottom < 80 ? "true" : "false",
      );
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    // Horizon scrolls `.page-wrapper` (html/body are overflow:hidden on desktop).
    var pageWrapper = document.querySelector(".page-wrapper");
    if (pageWrapper) {
      pageWrapper.addEventListener("scroll", onScroll, { passive: true });
    }
  }

  function bindCustomerTransformationTestimonials() {
    document.querySelectorAll("[data-ecomato-ctt]").forEach(function (section) {
      var track = section.querySelector("[data-ecomato-ctt-track]");
      var dots = section.querySelectorAll(".ecomato-ctt__dot");
      var prev = section.querySelector(".ecomato-ctt__nav--prev");
      var next = section.querySelector(".ecomato-ctt__nav--next");
      if (!track) return;

      var slides = track.querySelectorAll(".ecomato-ctt__slide");
      var count = slides.length;
      var active = 0;
      var looping = false;
      if (!count) return;

      var visibleObserver = new IntersectionObserver(
        function (entries) {
          if (
            entries.some(function (entry) {
              return entry.isIntersecting;
            })
          ) {
            section.setAttribute("data-visible", "true");
            visibleObserver.disconnect();
          }
        },
        { threshold: 0.2 },
      );
      visibleObserver.observe(section);

      function stepSize() {
        var slide = slides[0];
        if (!slide) return 0;
        var gap = parseFloat(window.getComputedStyle(track).gap || "0");
        return slide.offsetWidth + gap;
      }

      function setActive(index) {
        active = ((index % count) + count) % count;
        dots.forEach(function (dot, dotIndex) {
          dot.setAttribute("data-active", dotIndex === active ? "true" : "false");
        });
      }

      function goTo(index) {
        var step = stepSize();
        if (!step) return;
        looping = true;
        track.scrollTo({ left: index * step, behavior: "smooth" });
        setActive(index);
        window.setTimeout(function () {
          looping = false;
        }, 450);
      }

      function sync() {
        if (looping) return;
        var step = stepSize();
        if (!step) return;
        setActive(Math.round(track.scrollLeft / step));
      }

      track.addEventListener("scroll", sync, { passive: true });
      if (prev) {
        prev.addEventListener("click", function () {
          goTo(active - 1 < 0 ? count - 1 : active - 1);
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          goTo(active + 1 >= count ? 0 : active + 1);
        });
      }
      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          goTo(Number(dot.getAttribute("data-index") || "0"));
        });
      });
      setActive(0);
    });
  }

  function getScrollParents(el) {
    var nodes = [window];
    var node = el.parentElement;
    while (node && node !== document.documentElement) {
      var style = window.getComputedStyle(node);
      var oy = style.overflowY;
      if (oy === "auto" || oy === "scroll" || oy === "overlay") {
        nodes.push(node);
      }
      node = node.parentElement;
    }
    return nodes;
  }

  function bindWarmlyHeader(root) {
    var scope = root || document;
    scope.querySelectorAll("[data-ecomato-warmly-v2-header]").forEach(function (header) {
      if (header.getAttribute("data-emh-bound") === "true") return;
      header.setAttribute("data-emh-bound", "true");

      var section = header.closest(".shopify-section") || header;
      var spacer = document.createElement("div");
      spacer.setAttribute("data-ecomato-warmly-v2-header-spacer", "");
      spacer.style.display = "none";
      spacer.setAttribute("aria-hidden", "true");
      if (section.parentNode) {
        section.parentNode.insertBefore(spacer, section);
      }
      var pinned = false;

      var setPinned = function (enable) {
        if (enable === pinned) return;
        pinned = enable;
        if (enable) {
          spacer.style.display = "block";
          spacer.style.height = section.offsetHeight + "px";
          section.style.position = "fixed";
          section.style.top = "0";
          section.style.left = "0";
          section.style.right = "0";
          section.style.width = "100%";
          section.style.zIndex = "40";
          header.classList.add("is-scrolled");
        } else {
          spacer.style.display = "none";
          spacer.style.height = "0px";
          section.style.position = "";
          section.style.top = "";
          section.style.left = "";
          section.style.right = "";
          section.style.width = "";
          section.style.zIndex = "";
          header.classList.remove("is-scrolled");
        }
      };

      var onScroll = function () {
        var stickyOn = header.getAttribute("data-sticky") === "true";
        if (!stickyOn) {
          setPinned(false);
          header.classList.remove("is-scrolled");
          return;
        }
        var top = pinned
          ? spacer.getBoundingClientRect().top
          : section.getBoundingClientRect().top;
        setPinned(top <= 0);
        if (!pinned) {
          header.classList.toggle("is-scrolled", window.scrollY > 8);
        }
      };
      onScroll();
      getScrollParents(header).forEach(function (target) {
        target.addEventListener("scroll", onScroll, { passive: true });
      });
      window.addEventListener("resize", onScroll, { passive: true });

      bindHeaderMenuDrawer(header);
      bindHeaderMobileSearchToggle(header);
      bindHeaderMegaMenu(header);
      bindHeaderSearch(header);
    });
  }

  /**
   * Mobile menu drawer — hamburger toggle, overlay click, ESC, scroll lock,
   * and an accordion for nav items with nested children.
   */
  function bindHeaderMenuDrawer(header) {
    var section =
      header.closest(".shopify-section") ||
      header.closest(".ecomato-warmly-v2-header-section") ||
      header.parentElement ||
      header;
    var toggle = header.querySelector("[data-ecomato-warmly-v2-menu-toggle]");
    var drawer = section.querySelector("[data-ecomato-warmly-v2-menu-drawer]");
    var overlay = section.querySelector("[data-ecomato-warmly-v2-menu-overlay]");
    var closeBtn = section.querySelector("[data-ecomato-warmly-v2-menu-close]");
    if (!toggle || !drawer) return;

    var menuOpenIcon = toggle.querySelector(".ecomato-warmly-v2-header__menu-btn-open");
    var menuCloseIcon = toggle.querySelector(".ecomato-warmly-v2-header__menu-btn-close");

    var setMenuIcons = function (open) {
      if (menuOpenIcon) {
        if (open) menuOpenIcon.setAttribute("hidden", "");
        else menuOpenIcon.removeAttribute("hidden");
      }
      if (menuCloseIcon) {
        if (open) menuCloseIcon.removeAttribute("hidden");
        else menuCloseIcon.setAttribute("hidden", "");
      }
    };

    var closeSearchIfOpen = function () {
      var searchToggle = header.querySelector("[data-ecomato-warmly-v2-search-toggle]");
      if (!searchToggle) return;
      var searchPanelId = searchToggle.getAttribute("aria-controls");
      var searchPanel = searchPanelId
        ? header.querySelector("#" + CSS.escape(searchPanelId))
        : null;
      var searchOpenIcon = searchToggle.querySelector(
        ".ecomato-warmly-v2-header__mobile-search-toggle-open",
      );
      var searchCloseIcon = searchToggle.querySelector(
        ".ecomato-warmly-v2-header__mobile-search-toggle-close",
      );
      if (searchPanel) searchPanel.setAttribute("hidden", "");
      searchToggle.setAttribute("aria-expanded", "false");
      searchToggle.setAttribute("aria-label", "Open search");
      if (searchOpenIcon) searchOpenIcon.removeAttribute("hidden");
      if (searchCloseIcon) searchCloseIcon.setAttribute("hidden", "");
    };

    var openDrawer = function () {
      closeSearchIfOpen();
      drawer.removeAttribute("hidden");
      if (overlay) overlay.removeAttribute("hidden");
      // rAF so the `hidden` removal paints before the transition class flips.
      requestAnimationFrame(function () {
        drawer.classList.add("is-open");
        if (overlay) overlay.classList.add("is-visible");
      });
      header.classList.add("is-menu-open");
      if (section !== header) section.classList.add("is-menu-open");
      toggle.setAttribute("aria-expanded", "true");
      toggle.setAttribute("aria-label", "Close menu");
      setMenuIcons(true);
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    };

    var closeDrawer = function () {
      drawer.classList.remove("is-open");
      if (overlay) overlay.classList.remove("is-visible");
      header.classList.remove("is-menu-open");
      if (section !== header) section.classList.remove("is-menu-open");
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
      setMenuIcons(false);
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      window.setTimeout(function () {
        if (!drawer.classList.contains("is-open")) {
          drawer.setAttribute("hidden", "");
          if (overlay) overlay.setAttribute("hidden", "");
        }
      }, 240);
    };

    var isOpen = function () {
      return !drawer.hasAttribute("hidden");
    };

    toggle.addEventListener("click", function () {
      if (isOpen()) closeDrawer();
      else openDrawer();
    });
    if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
    if (overlay) overlay.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isOpen()) closeDrawer();
    });

    // Accordion — nav items with children (from Shopify menu `link.links`).
    drawer.querySelectorAll("[data-ecomato-accordion-trigger]").forEach(function (trigger) {
      var panelId = trigger.getAttribute("aria-controls");
      var panel = panelId ? drawer.querySelector("#" + CSS.escape(panelId)) : null;
      if (!panel) return;
      trigger.addEventListener("click", function () {
        var expanded = trigger.getAttribute("aria-expanded") === "true";
        trigger.setAttribute("aria-expanded", String(!expanded));
        trigger.classList.toggle("is-expanded", !expanded);
        if (expanded) panel.setAttribute("hidden", "");
        else panel.removeAttribute("hidden");
      });
    });

    // Language selector disclosure inside the drawer reuses the shared
    // `bindWarmlyLocalization` binder (invoked separately in boot()/section:load)
    // via the generic [data-ecomato-locale-*] attributes — no extra wiring here.
  }

  /**
   * Mobile search — toggles the inline search panel under the mobile bar.
   */
  function bindHeaderMobileSearchToggle(header) {
    var toggle = header.querySelector("[data-ecomato-warmly-v2-search-toggle]");
    if (!toggle) return;
    var panelId = toggle.getAttribute("aria-controls");
    var panel = panelId ? header.querySelector("#" + CSS.escape(panelId)) : null;
    if (!panel) return;
    var searchOpenIcon = toggle.querySelector(
      ".ecomato-warmly-v2-header__mobile-search-toggle-open",
    );
    var searchCloseIcon = toggle.querySelector(
      ".ecomato-warmly-v2-header__mobile-search-toggle-close",
    );

    var setSearchIcons = function (open) {
      if (searchOpenIcon) {
        if (open) searchOpenIcon.setAttribute("hidden", "");
        else searchOpenIcon.removeAttribute("hidden");
      }
      if (searchCloseIcon) {
        if (open) searchCloseIcon.removeAttribute("hidden");
        else searchCloseIcon.setAttribute("hidden", "");
      }
    };

    var closeMenuIfOpen = function () {
      var menuToggle = header.querySelector("[data-ecomato-warmly-v2-menu-toggle]");
      var section =
        header.closest(".shopify-section") ||
        header.closest(".ecomato-warmly-v2-header-section") ||
        header.parentElement ||
        header;
      var drawer = section.querySelector("[data-ecomato-warmly-v2-menu-drawer]");
      var overlay = section.querySelector("[data-ecomato-warmly-v2-menu-overlay]");
      if (!menuToggle || !drawer || drawer.hasAttribute("hidden")) return;
      drawer.classList.remove("is-open");
      if (overlay) overlay.classList.remove("is-visible");
      header.classList.remove("is-menu-open");
      if (section !== header) section.classList.remove("is-menu-open");
      menuToggle.setAttribute("aria-expanded", "false");
      menuToggle.setAttribute("aria-label", "Open menu");
      var menuOpenIcon = menuToggle.querySelector(".ecomato-warmly-v2-header__menu-btn-open");
      var menuCloseIcon = menuToggle.querySelector(".ecomato-warmly-v2-header__menu-btn-close");
      if (menuOpenIcon) menuOpenIcon.removeAttribute("hidden");
      if (menuCloseIcon) menuCloseIcon.setAttribute("hidden", "");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      drawer.setAttribute("hidden", "");
      if (overlay) overlay.setAttribute("hidden", "");
    };

    toggle.addEventListener("click", function () {
      var open = panel.hasAttribute("hidden");
      if (open) {
        closeMenuIfOpen();
        panel.removeAttribute("hidden");
        toggle.setAttribute("aria-expanded", "true");
        toggle.setAttribute("aria-label", "Close search");
        setSearchIcons(true);
        var input = panel.querySelector("[data-ecomato-search-input]");
        if (input) input.focus();
      } else {
        panel.setAttribute("hidden", "");
        toggle.setAttribute("aria-expanded", "false");
        toggle.setAttribute("aria-label", "Open search");
        setSearchIcons(false);
      }
    });
  }

  /**
   * Desktop mega menu — hover, focus, and keyboard support for nav items
   * that have nested children (Shopify menu `link.links`).
   */
  function bindHeaderMegaMenu(header) {
    var items = header.querySelectorAll(
      ".ecomato-warmly-v2-header__surface--desktop [data-ecomato-nav-item].has-children",
    );
    if (!items.length) return;

    var closeItem = function (item) {
      item.classList.remove("is-open");
      var trigger = item.querySelector("[data-ecomato-nav-trigger]");
      var chevron = item.querySelector("[data-ecomato-nav-chevron]");
      var panel = item.querySelector("[data-ecomato-nav-panel]");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (chevron) chevron.setAttribute("aria-expanded", "false");
      if (panel) panel.setAttribute("hidden", "");
    };

    var openItem = function (item) {
      items.forEach(function (other) {
        if (other !== item) closeItem(other);
      });
      item.classList.add("is-open");
      var trigger = item.querySelector("[data-ecomato-nav-trigger]");
      var chevron = item.querySelector("[data-ecomato-nav-chevron]");
      var panel = item.querySelector("[data-ecomato-nav-panel]");
      if (trigger) trigger.setAttribute("aria-expanded", "true");
      if (chevron) chevron.setAttribute("aria-expanded", "true");
      if (panel) panel.removeAttribute("hidden");
    };

    items.forEach(function (item) {
      var trigger = item.querySelector("[data-ecomato-nav-trigger]");
      var chevron = item.querySelector("[data-ecomato-nav-chevron]");

      item.addEventListener("mouseenter", function () {
        openItem(item);
      });
      item.addEventListener("mouseleave", function () {
        closeItem(item);
      });
      if (trigger) {
        trigger.addEventListener("focus", function () {
          openItem(item);
        });
      }
      if (chevron) {
        chevron.addEventListener("click", function (event) {
          event.preventDefault();
          if (item.classList.contains("is-open")) closeItem(item);
          else openItem(item);
        });
      }
      item.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && item.classList.contains("is-open")) {
          closeItem(item);
          if (trigger) trigger.focus();
        }
      });
    });

    // Click outside or focus leaving the nav closes any open mega menu.
    document.addEventListener("click", function (event) {
      var nav = header.querySelector("[data-ecomato-warmly-v2-nav]");
      if (nav && nav.contains(event.target)) return;
      items.forEach(closeItem);
    });
    header.addEventListener("focusout", function (event) {
      window.setTimeout(function () {
        items.forEach(function (item) {
          if (!item.classList.contains("is-open")) return;
          if (item.contains(document.activeElement)) return;
          closeItem(item);
        });
      }, 0);
    });
  }

  /**
   * Predictive search combobox — shared by the desktop search bar and the
   * mobile search panel. Debounced (280ms) + AbortController, matching the
   * pattern in ecomato-warmly-v2-home-search.liquid, but wired against
   * `routes.predictive_search_url` (passed via a data attribute since this
   * file is a static asset, not a .liquid template).
   */
  function bindHeaderSearch(header) {
    var baseUrl = header.getAttribute("data-predictive-search-url") || "/search/suggest";

    header.querySelectorAll("[data-ecomato-header-search]").forEach(function (root) {
      if (root.getAttribute("data-search-bound") === "true") return;
      root.setAttribute("data-search-bound", "true");

      var form = root.querySelector("[data-ecomato-search-form]");
      var input = root.querySelector("[data-ecomato-search-input]");
      var dropdown = root.querySelector("[data-ecomato-search-dropdown]");
      var category = root.querySelector("[data-ecomato-search-category]");
      if (!form || !input || !dropdown) return;

      var enablePredictive = root.getAttribute("data-enable-predictive") !== "false";
      var maxResults = Number(root.getAttribute("data-max-results") || 6);
      var timer = null;
      var controller = null;
      var requestId = 0;
      var activeIndex = -1;
      var flatItems = [];

      function escapeHtml(value) {
        return String(value || "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      }

      function moneyFromCents(cents) {
        var n = Number(cents);
        if (!Number.isFinite(n)) return "";
        return "$" + (n / 100).toFixed(2);
      }

      function closeDropdown() {
        dropdown.hidden = true;
        input.setAttribute("aria-expanded", "false");
        activeIndex = -1;
        flatItems = [];
      }

      function openDropdown() {
        dropdown.hidden = false;
        input.setAttribute("aria-expanded", "true");
      }

      function renderStatus(text) {
        dropdown.innerHTML =
          '<p class="ecomato-warmly-v2-header__search-status">' + escapeHtml(text) + "</p>";
        openDropdown();
      }

      function syncActive() {
        dropdown.querySelectorAll("[data-flat-index]").forEach(function (el) {
          var idx = Number(el.getAttribute("data-flat-index"));
          el.classList.toggle("is-active", idx === activeIndex);
        });
      }

      function renderResults(payload) {
        var results = (payload && payload.resources && payload.resources.results) || {};
        var queries = (results.queries || []).slice(0, maxResults);
        var products = (results.products || []).slice(0, maxResults);
        var articles = (results.articles || []).slice(0, maxResults);
        flatItems = [];
        activeIndex = -1;

        if (!queries.length && !products.length && !articles.length) {
          renderStatus("No results found");
          return;
        }

        var html = "";
        if (queries.length) {
          html += '<ul class="ecomato-warmly-v2-header__search-list">';
          queries.forEach(function (item) {
            flatItems.push({ type: "query", url: item.url || "" });
            html +=
              '<li><a class="ecomato-warmly-v2-header__search-option" role="option" href="' +
              escapeHtml(item.url || "") +
              '" data-flat-index="' +
              (flatItems.length - 1) +
              '">' +
              escapeHtml(item.text || "") +
              "</a></li>";
          });
          html += "</ul>";
        }
        if (products.length) {
          html += '<ul class="ecomato-warmly-v2-header__search-list ecomato-warmly-v2-header__search-products">';
          products.forEach(function (product) {
            flatItems.push({ type: "product", url: product.url || "" });
            var image = product.image || (product.featured_image && product.featured_image.url) || "";
            var price =
              typeof product.price === "number" ? moneyFromCents(product.price) : product.price || "";
            html +=
              '<li><a class="ecomato-warmly-v2-header__search-option ecomato-warmly-v2-header__search-product" role="option" href="' +
              escapeHtml(product.url || "") +
              '" data-flat-index="' +
              (flatItems.length - 1) +
              '">';
            html += image
              ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">'
              : '<span class="ecomato-warmly-v2-header__search-product-fallback" aria-hidden="true"></span>';
            html +=
              '<span><span class="ecomato-warmly-v2-header__search-product-title">' +
              escapeHtml(product.title || "") +
              "</span>";
            if (price) {
              html +=
                '<span class="ecomato-warmly-v2-header__search-product-price">' + escapeHtml(price) + "</span>";
            }
            html += "</span></a></li>";
          });
          html += "</ul>";
        }
        if (articles.length) {
          html += '<ul class="ecomato-warmly-v2-header__search-list">';
          articles.forEach(function (article) {
            flatItems.push({ type: "article", url: article.url || "" });
            html +=
              '<li><a class="ecomato-warmly-v2-header__search-option" role="option" href="' +
              escapeHtml(article.url || "") +
              '" data-flat-index="' +
              (flatItems.length - 1) +
              '">' +
              escapeHtml(article.title || "") +
              "</a></li>";
          });
          html += "</ul>";
        }

        dropdown.innerHTML = html;
        openDropdown();
      }

      function fetchResults(term) {
        if (!enablePredictive) return;
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var id = ++requestId;
        renderStatus("Searching…");
        var limit = Math.max(1, Math.min(10, maxResults));
        var url =
          baseUrl +
          ".json?q=" +
          encodeURIComponent(term) +
          "&resources[type]=query,product,article" +
          "&resources[limit]=" +
          encodeURIComponent(String(limit)) +
          "&resources[limit_scope]=each" +
          "&resources[options][unavailable_products]=show";

        fetch(url, { signal: controller ? controller.signal : undefined })
          .then(function (response) {
            if (!response.ok) throw new Error("Search failed");
            return response.json();
          })
          .then(function (json) {
            if (id !== requestId) return;
            renderResults(json);
          })
          .catch(function (error) {
            if (error && error.name === "AbortError") return;
            if (id !== requestId) return;
            renderStatus("No results found");
          });
      }

      input.addEventListener("input", function () {
        var term = String(input.value || "").trim();
        window.clearTimeout(timer);
        if (!term) {
          closeDropdown();
          return;
        }
        timer = window.setTimeout(function () {
          fetchResults(term);
        }, 280);
      });

      input.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          event.preventDefault();
          closeDropdown();
          return;
        }
        if (dropdown.hidden || !flatItems.length) return;
        if (event.key === "ArrowDown") {
          event.preventDefault();
          activeIndex = (activeIndex + 1) % flatItems.length;
          syncActive();
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          activeIndex = activeIndex <= 0 ? flatItems.length - 1 : activeIndex - 1;
          syncActive();
        } else if (event.key === "Enter" && activeIndex >= 0) {
          var item = flatItems[activeIndex];
          if (!item || !item.url) return;
          event.preventDefault();
          window.location.assign(item.url);
        }
      });

      // Category selector — points the base search form at a specific
      // collection URL (Empire's "simple All categories select linking to
      // search with type"); resets to the sitewide search URL when cleared.
      if (category) {
        var baseSearchUrl = form.getAttribute("data-ecomato-search-base-url") || form.action;
        category.addEventListener("change", function () {
          form.action = category.value || baseSearchUrl;
        });
      }

      form.addEventListener("submit", function () {
        closeDropdown();
      });

      document.addEventListener("mousedown", function (event) {
        if (event.target && root.contains(event.target)) return;
        closeDropdown();
      });
    });
  }

  function bindWarmlyLocalization(root) {
    var scope = root || document;
    scope.querySelectorAll("[data-ecomato-warmly-v2-localize]").forEach(function (wrap) {
      if (wrap.getAttribute("data-eml-bound") === "true") return;
      wrap.setAttribute("data-eml-bound", "true");

      wrap.querySelectorAll("[data-ecomato-locale-disclosure]").forEach(function (disclosure) {
        var toggle = disclosure.querySelector("[data-ecomato-locale-toggle]");
        var menu = disclosure.querySelector("[data-ecomato-locale-menu]");
        if (!toggle || !menu) return;

        toggle.addEventListener("click", function (event) {
          event.preventDefault();
          var open = menu.hasAttribute("hidden");
          wrap.querySelectorAll("[data-ecomato-locale-menu]").forEach(function (other) {
            other.setAttribute("hidden", "");
          });
          wrap.querySelectorAll("[data-ecomato-locale-toggle]").forEach(function (btn) {
            btn.setAttribute("aria-expanded", "false");
          });
          if (open) {
            menu.removeAttribute("hidden");
            toggle.setAttribute("aria-expanded", "true");
          }
        });
      });
    });

    if (!document.documentElement.getAttribute("data-eml-doc-bound")) {
      document.documentElement.setAttribute("data-eml-doc-bound", "true");
      document.addEventListener("click", function (event) {
        if (event.target.closest("[data-ecomato-locale-disclosure]")) return;
        document.querySelectorAll("[data-ecomato-locale-menu]").forEach(function (menu) {
          menu.setAttribute("hidden", "");
        });
        document.querySelectorAll("[data-ecomato-locale-toggle]").forEach(function (btn) {
          btn.setAttribute("aria-expanded", "false");
        });
      });
      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        document.querySelectorAll("[data-ecomato-locale-menu]").forEach(function (menu) {
          menu.setAttribute("hidden", "");
        });
        document.querySelectorAll("[data-ecomato-locale-toggle]").forEach(function (btn) {
          btn.setAttribute("aria-expanded", "false");
        });
      });
    }
  }

  function boot() {
    bindSticky(document);
    bindCustomerTransformationTestimonials();
    bindWarmlyHeader(document);
    bindWarmlyLocalization(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target) {
      bindSticky(event.target);
      bindWarmlyHeader(event.target);
      bindWarmlyLocalization(event.target);
    }
  });
})();
